import React from 'react';
import './terms-conditions-policies.scss';
import PropTypes from 'prop-types';
import TcpHeader from './views/tcp-header/tcp-header';
import PrivacyPolicy from './views/privacy-policy/privacy-policy';
import TermsConditions from './views/terms-conditions/terms-conditions';

const TcpTypes = {
  TERMS_CONDITIONS: 'terms-conditions',
  PRIVACY_POLICY: 'privacy-policy',
};

const TermsConditionsPolicies = ({ type }) => {
  let view = null;

  switch (type) {
    case TcpTypes.TERMS_CONDITIONS:
      view = <TermsConditions />;
      break;
    case TcpTypes.PRIVACY_POLICY:
    default:
      view = <PrivacyPolicy />;
  }

  return (
    <div className="tcp-slice">
      <TcpHeader />
      {view}
    </div>
  );
};

TermsConditionsPolicies.propTypes = {
  type: PropTypes.oneOf(Object.values(TcpTypes)),
};

TermsConditionsPolicies.defaultProps = {
  type: TcpTypes.TERMS_CONDITIONS,
};

export {
  TermsConditionsPolicies as default,
  TcpTypes,
};
